import type { CreatorFeatures } from '@/modules/accounts/types.ts'
import type { Creator } from '@/modules/creators/types.ts'

export enum LicenseMode {
  YEARLY = 'yearly',
  MONTHLY = 'monthly',
}

export interface BillingPlan {
  name: string
  displayBenefits: string[]
  displayNonBenefits: string[]
  specialFeatures: CreatorFeatures[]
  displayName: string
  helpDeskLink: string
  level: number
  monthlyPrice: number
  yearlyPrice: number
}

export interface LicensesTableType {
  licenseId: number
  planDisplayName: string
  planName: string
  planLevel: number
  planVariantName: string
  isCreatorConnected: boolean
  isYearly: boolean
  creator: Creator | undefined
  disabled: boolean
}

export interface License {
  id: number
  quantity: number
  plan: string
  disabled: boolean
  activeUsed: number
}

export interface PurchasePlanInfo {
  planName: string
  planDisplayName: string
  price: {
    priceId: string
    price: number
    planType: string
    formattedPrice: string
  }
  priceId: string
}

export interface PurchasePreviewInfo {
  planPrice: PlanPrice
  customerBalance: number
  dueNowExcludingTax: number
  dueNowIncludingTax: number
  dueNowTax: number
  dueNowPeriodStart: string
  dueNowPeriodEnd: string
  paymentAmount: number
}

export interface PurchaseContext {
  creatorId: number
  anticipatedPrice: number
  planPrice: string
  quantity: number
}

export interface ConnectLicenseContext {
  creatorId: number
  licenseId: number
}

export interface UpgradeContext {
  creatorId: number
  planPrice: string
}

export interface UpgradeLicenseInfo {
  planPrice: PlanPrice
  customerBalance: number
  creditExcludingTax: number
  creditIncludingTax: number
  creditTax: number
  creditPeriodStart: string
  creditPeriodEnd: string
  dueNowExcludingTax: number
  dueNowIncludingTax: number
  dueNowTax: number
  dueNowPeriodStart: string
  dueNowPeriodEnd: string
  paymentAmount: number
}

export interface PurchaseExecutionInfo {
  paymentSuccessful: boolean
  invoicePaymentPage: string
}

export interface PlanPrice {
  priceId: string
  price: number
  planType: string
  formattedPrice: string
}
